import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { ClickAwayListener, Grow, Popper } from '@material-ui/core'
import ScrollContent from '../../../molecules/ScrollContent'
import InlineSearchInput from './InlineSearchInput'
import SelectMenuOption from './SelectMenuOption'

function SelectPopoverMenu ({
  anchorEl,
  open,
  setOpen,
  options,
  pinnedOptions,
  onSearchChange,
  onSelect
}) {
  const handleClose = useCallback(() => setOpen(false), [setOpen])
  const animateMenu = useCallback(({ TransitionProps, placement }) => {
    return (
      <Grow {...TransitionProps} style={{ transformOrigin: 'top' }}>
        <ScrollContent className='opal-drop-menu below select-none' maxHeight='300px'>
          <ClickAwayListener onClickAway={handleClose}>
            <div className='flex flex-col'>
              <div>
                <InlineSearchInput onChange={onSearchChange} />
              </div>
              {(pinnedOptions || []).length ? (
                <>
                  {pinnedOptions.map(option => (
                    <SelectMenuOption key={`pi_${option.value}`} option={option} onClick={onSelect} />
                  ))}
                  <div className='divider' />
                </>
              ) : null}
              {(options || []).map(option => (
                <SelectMenuOption key={`mi_${option.value}`} option={option} onClick={onSelect} />
              ))}
              {((pinnedOptions || []).length + (options || []).length) === 0 ? (
                <div className='p-sm flex justify-center font-size-sm'>
                  No results
                </div>
              ) : null}
            </div>
          </ClickAwayListener>
        </ScrollContent>
      </Grow>
    )
  }, [handleClose, onSelect, onSearchChange, options, pinnedOptions])

  return (
    <Popper
      transition
      open={open}
      placement='bottom-start'
      className='z-index-dropdown'
      anchorEl={anchorEl}
    >
      {animateMenu}
    </Popper>
  )
}

SelectPopoverMenu.propTypes = {
  anchorEl: PropTypes.any,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  options: PropTypes.array,
  pinnedOptions: PropTypes.array,
  onSearchChange: PropTypes.func,
  onSelect: PropTypes.func
}

export default SelectPopoverMenu
